import React, { useEffect, useMemo, useState } from 'react';
import { HeaderStyled, sxHeader } from './header.styled';
import { SvgImage, SvgType } from '../../../../base/svg/svg';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {
  logoutAction,
  logoutResetState,
} from '../../../../../store/auth/logout.store';
import { useNavigate } from 'react-router-dom';
import {
  userResetState,
  UserTypeVariant,
} from '../../../../../store/user.store';
import i18n from '../../../../../translations/strings';
import { ModalVariant } from '../../../modal-provider/components/modal/modal.constants';
import { useModal } from '../../../modal-provider/hooks/modal-provider.hook';
import { makeReservationResetState } from '../../../../../store/shared/make-reservation.store';
import { getReservationListResetState } from '../../../../../store/shared/reservations-list.store';
import { handleReservationResetState } from '../../../../../store/admin/handle-reservation.store';
import { landingResetState } from '../../../../../store/customers/landing.store';

export interface HeaderProps {
  onHamburgerClick: () => void;
}

const Header = (props: HeaderProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { openModal } = useModal();

  const [openUserMenu, setOpenUserMenu] = useState(false);
  const [anchorElMenu, setAnchorElMenu] = React.useState<null | HTMLElement>(
    null,
  );

  const { user, userType } = useSelector((state: any) => {
    return state.user;
  });

  const { logoutSuccess, loading, error } = useSelector((state: any) => {
    return state.logout;
  });

  const handleClose = () => {
    setOpenUserMenu(false);
    setAnchorElMenu(null);
  };

  const toggleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
    setOpenUserMenu(!openUserMenu);
  };

  const listMenuCustomer = useMemo(() => {
    return [
      {
        title: 'Logout ',
        onClick: () => dispatch(logoutAction()),
      },
      {
        title: 'Gestisci profilo',
        onClick: () => navigate('/customer/edit-profile'),
      },
      {
        title: 'Cambia Password',
        onClick: () => navigate('/change-password', { replace: true }),
      },
    ];
  }, []);

  const listMenuAdmin = useMemo(() => {
    return [
      {
        title: 'Logout',
        onClick: () => dispatch(logoutAction()),
      },
      {
        title: 'Cambia Password',
        onClick: () => navigate('/change-password', { replace: true })//dispatch(changePasswordAction()),
      },
    ];
  }, []);

  const MenuListHeader: any = {
    [UserTypeVariant.Customer]: listMenuCustomer,
    [UserTypeVariant.Admin]: listMenuAdmin,
  };

  useEffect(() => {
    if (logoutSuccess) {
      dispatch(userResetState());
      dispatch(logoutResetState());
      dispatch(makeReservationResetState())
      dispatch(getReservationListResetState())
      dispatch(handleReservationResetState())
      dispatch(landingResetState())
      navigate('/', { replace: true });
    }
  }, [logoutSuccess]);

  useEffect(() => {
    if (error) {
      openModal({
        message: error,
        variant: ModalVariant.Error,
        handleCloseModal: () => dispatch(logoutResetState())
      })
    }
  }, [error]);

  return (
    <HeaderStyled.Container container>
      <HeaderStyled.ContainerLogo item xs={6}>
        <Grid
          display={{ md: 'none', xs: 'block' }}
          onClick={props.onHamburgerClick}
        >
          <SvgImage type={SvgType.Hamburger} />
        </Grid>
      </HeaderStyled.ContainerLogo>
      <HeaderStyled.ContainerMenuUser item xs={6}>
        <Grid item display={{ xs: 'none', md: 'block' }}>
          <HeaderStyled.MenuTitle>
            {`${i18n.t('dashboard.welcome')} ${user.first_name} ${
              user.last_name
            }`}
          </HeaderStyled.MenuTitle>
        </Grid>
        <HeaderStyled.ContainerIconMenu
          onClick={(event: React.MouseEvent<HTMLElement>) => toggleMenu(event)}
        >
          <AccountCircleIcon sx={sxHeader.accountIcon} />
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorElMenu}
            open={openUserMenu}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            {MenuListHeader[userType].map((option: any, index: number) => (
              <MenuItem
                key={index}
                sx={sxHeader.menuItem}
                onClick={option.onClick}
              >
                {option.title}
              </MenuItem>
            ))}
          </Menu>
        </HeaderStyled.ContainerIconMenu>
      </HeaderStyled.ContainerMenuUser>
    </HeaderStyled.Container>
  );
};

export default Header;
